// Optional learning-flow statistics. Never accept text, marks, identity or URLs.
export const BETA_EVENTS = ['btl_content_open', 'btl_operation'];
const FEATURES = new Set(['study_partner', 'explain', 'grade_pack', 'grade_own', 'draft_save', 'quiz_save']);
const VIEWS = new Set(['analysis', 'flashcards', 'quizzes', 'essays', 'section']);
const REASONS = new Set(['provider_error', 'malformed_model_output', 'source_disclosure_limited', 'rate_limited',
    'token_limited', 'regen_exhausted', 'not_entitled', 'not_configured', 'disabled', 'oversized',
    'unauthenticated', 'permission-denied', 'unavailable', 'resource-exhausted', 'deadline-exceeded',
    'invalid-argument', 'failed-precondition', 'cancelled', 'unknown']);
const safeId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,100}$/.test(value);
export function betaEventPayload(name, input = {}) {
    if (!BETA_EVENTS.includes(name)) return null;
    const out = {};
    if (safeId(input.pack_id)) out.pack_id = input.pack_id;
    if (name === 'btl_content_open') {
        if (!out.pack_id || !safeId(input.content_id) || !VIEWS.has(input.reader_view)) return null;
        return { ...out, content_id: input.content_id, reader_view: input.reader_view };
    }
    if (!FEATURES.has(input.feature) || !['started', 'succeeded', 'failed'].includes(input.outcome)) return null;
    Object.assign(out, { feature: input.feature, outcome: input.outcome });
    if (input.outcome !== 'started' && Number.isFinite(input.duration_ms) && input.duration_ms >= 0)
        out.duration_ms = Math.min(900000, Math.round(input.duration_ms / 100) * 100);
    if (['graded', 'feedback_only', 'clarification'].includes(input.result_type)) out.result_type = input.result_type;
    if (REASONS.has(input.reason_code)) out.reason_code = input.reason_code;
    return out;
}
